"use client";

import React from "react";
import { Dialog, DialogContent, Typography, Stack, Box } from "@mui/material";
import { ColletteIconButton } from "@collette-travel/collette-common-controls";
import CloseIcon from "@mui/icons-material/Close";

interface OfferTermsModalProps {
  isOpen: boolean;
  onClose: () => void;
  offerTitle?: string;
  termsAndConditions?: string;
}

const OfferTermsModal = ({
  isOpen,
  onClose,
  offerTitle = "Offer Details",
  termsAndConditions = ""
}: OfferTermsModalProps) => (
    <Dialog
      open={isOpen}
      onClose={onClose}
      disableScrollLock
      maxWidth="sm"
      fullWidth
      data-testid="offer-terms-modal"
    >
      <DialogContent
        sx={{
          padding: 0,
          position: "relative"
        }}
      >
        {/* Close Button */}
        <Box
          sx={{
            position: "absolute",
            top: "1.6rem",
            right: "1.6rem",
            zIndex: 1
          }}
        >
          <ColletteIconButton
            onClick={onClose}
            testId="close-offer-terms-modal"
            sx={{
              color: "text.primary"
            }}
          >
            <CloseIcon />
          </ColletteIconButton>
        </Box>

        {/* Content */}
        <Stack
          spacing={2}
          sx={{
            p: { xs: "2.4rem", sm: "4rem", md: "4rem 6rem" }
          }}
        >
          <Typography
            variant="h2"
            sx={{
              fontSize: "2.4rem",
              fontWeight: 600,
              color: "text.primary",
              marginBottom: "1.6rem"
            }}
          >
            {offerTitle}
          </Typography>

          <Typography
            sx={{
              fontSize: "1.6rem",
              fontWeight: 400,
              color: "text.primary",
              lineHeight: 1.5,
              whiteSpace: "pre-wrap"
            }}
          >
            {termsAndConditions}
          </Typography>
        </Stack>
      </DialogContent>
    </Dialog>
  );

export default OfferTermsModal;
